import { ISeason } from '../store';

import { IStore } from '../../index';

export const setCurrent = (state: IStore, clubId: number, currentSeason: ISeason) => {
  return {
    seasons: {
      ...state.seasons,
      [clubId]: {
        currentSeason,
        seasons: state.seasons[clubId].seasons
      }
    }
  };
};
